import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => createStyles({
  title: {
    fontSize: '1.125rem',
    fontWeight: 600,
    color: '#111827',
  },
  codeCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    transition: 'borderColor 0.2s',
    backgroundColor: 'white',
    marginBottom: '16px',
    cursor: 'default',
    padding: '0 5px',
  },
  codeLabel: {
    fontSize: '0.75rem',
    color: '#DB5C0E',
    letterSpacing: '0.05em',
    fontWeight: 600,
  },
  codeValue: {
    fontSize: '1.125rem',
    color: '#111827',
    fontWeight: 700,
  },
  modalWrapper: {
    borderRadius: '8px',
    padding: '20px',
    maxWidth: '400px',
    width: '100%',
    boxSizing: 'border-box',
  },
  modalTitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '30px',
    textAlign: 'center',
  },
  fieldWrapper: {
    marginBottom: '20px',
  },
  buttonWrapper: {
    gap: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  textField: {
    outline: 'none',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#d1d5db',
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
      },
      '&.Mui-focused fieldset': {
        borderWidth: '2px',
        borderColor: 'transparent',
      },
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: '#9ca3af',
      opacity: 1,
    },
    '& .MuiOutlinedInput-input': {
      marginLeft: 0,
    },
    '& .MuiInputLabel-outlined': {
      backgroundColor: '#fff',
      padding: '0 4px',
      zIndex: 100,
    },
  },
  progress: {
    color: theme.appPalette.orange,
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
  progressWrapper: {
    position: 'relative',
    height: '100%',
  },
});
